'use client';
/*
 * Documentation:
 * Empty State — https://app.subframe.com/6fc7f5fbb098/library?component=Empty+State_bdceed43-3e3a-4f6e-86f1-1e7578935af4
 * Icon with background — https://app.subframe.com/6fc7f5fbb098/library?component=Icon+with+background_c5d68c0e-4c0c-4cff-8d8c-6ff334859b3a
 */

import React from 'react';
import { FeatherFileText } from '@subframe/core';
import * as SubframeCore from '@subframe/core';
import * as SubframeUtils from '../utils';
import { IconWithBackground } from './IconWithBackground';

interface EmptyStateRootProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

const EmptyStateRoot = React.forwardRef<HTMLDivElement, EmptyStateRootProps>(
  function EmptyStateRoot(
    {
      icon = <FeatherFileText />,
      title,
      description,
      action,
      className,
      ...otherProps
    }: EmptyStateRootProps,
    ref,
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          'flex h-full w-full flex-col items-center justify-center gap-6 px-12 py-12',
          className,
        )}
        ref={ref}
        {...otherProps}
      >
        <div className="flex flex-col items-center gap-4">
          <div className="flex flex-col items-start gap-2">
            <IconWithBackground variant="neutral" size="large" icon={icon} />
          </div>
          <div className="flex flex-col items-center gap-1">
            {title ? (
              <span className="text-body-bold font-body-bold text-default-font">{title}</span>
            ) : null}
            {description ? (
              <span className="text-body font-body text-subtext-color text-center">
                {description}
              </span>
            ) : null}
          </div>
        </div>
        {action ? <div className="flex items-start gap-2">{action}</div> : null}
      </div>
    );
  },
);

export const EmptyState = EmptyStateRoot;
